// 交易异常记录

import { HttpAbnormalBillList, HttpRetryAbnormal } from '@/service/billing';
import TableList from "@components/templates/tablelist";
// import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpAbnormalBillList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'retry':
                    if (params.split(',').length < 2) {
                        this.operate = {
                            show: true,
                            alert: 'primary',
                            params: { id: params },
                            title: this.$t('fbb.bill.abnormal_retry', { defaultValue: '重试' }),
                            ajaxRequest: HttpRetryAbnormal
                        }
                    } else {
                        this.$VMessage.error(this.$t('fbb.billmanage.only_one', { defaultValue: '只能选择一条数据' }))
                    }

                    break;
            }
        },
    },
    computed: {
        ToolsData() {
            return [
                {
                    name: this.$t('fbb.bill.abnormal_retry', { defaultValue: '重试' }),
                    operate: "retry",
                    theme: "info",
                    batch: true
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.bill.abnormal_createdat', { defaultValue: '交易时间' }),
                    key: 'BT_createdAt',
                    show: true,
                    tag: 'vDatepicker',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('fbb.bill.freeze_type', { defaultValue: '类型' }),
                    key: 'EQ_type',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillType
                },
                {
                    label:  this.$t('fbb.adjustment.list_secondcategory', { defaultValue: '二级分类' }),
                    key: 'EQ_category',
                    show: true,
                    tag: 'vSelect',
                    options: this.getCategory,
                },
                {
                    label: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
                    key: 'EQ_extraId',
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
                    key: 'EQ_trackingNo',
                    tag: 'vInput',
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('fbb.bill.abnormal_createdat', { defaultValue: '交易时间' }),
                    key: 'createdAt',
                }, {
                    title: this.$t('fbb.bill.freeze_type', { defaultValue: '类型' }),
                    key: 'type',
                    // render: (h, { row }) => row.type == 1 ? '支出' : '收入'
                    render: (h, { row }) => this.findRenderLabel(this.getBillType, row.type)
                },
                {
                    title: this.$t('fbb.adjustment.list_secondcategory', { defaultValue: '二级分类' }),
                    key: 'category',
                    render: (h, { row }) => this.findRenderLabel(this.getCategory, row.category)
                },
                {
                    title: this.$t('fbb.alloment.order_status', { defaultValue: '状态' }),
                    key: 'status',
                    render: (h, { row }) => {
                        return row.status == 1 ? this.$t('fbb.bill.abnormal_process', { defaultValue: '已处理' }): this.$t('fbb.bill.abnormal_unprocess', { defaultValue: '未处理' })
                    }
                },
                {
                    title: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
                    key: 'trackingNo',
                },
                {
                    title: this.$t('fbb.bill.abnormal_amount', { defaultValue: '交易金额' }),
                    key: 'amount',
                },
                {
                    title: this.$t('global.common.currency', { defaultValue: '币种' }),
                    // key: 'currency',
                    render: (h, { row }) => {
                        return <div>{row.currency || 'USD'}</div>
                    }
                },
                {
                    title: this.$t('fbb.costmanage.explain', { defaultValue: '说明' }), 
                    key: 'remark',
                },
                {
                    title: this.$t('fbb.costmanage.exception_tip', { defaultValue: '异常说明' }), 
                    key: 'remark',
                }];
        },
    },
};




